import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";
import Home from "../pages/Home";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import Login from "../pages/Login";
import TermsCondition from "../component/TermsOfService/TermsCOndition";
import PrivacyPolacy from "../component/PrivacyPolacy/PrivacyPolacy";
import Products from "../pages/Products";
import Platforms from "../pages/Platforms";
import Contact from "../pages/Contact";
import About from "../pages/About";
import Profile from "../profile/Profile";
import EditProfile from "../profile/EditProfile";
import DeleteAccount from "../profile/DeleteAccount";
import Orders from "../profile/Orders";
import Downloads from "../profile/Downloads";
import GameDetails from "../pages/GameDetails";
import Bundles from "../pages/Bundles";
import Cart from "../pages/Cart";
import Wishlist from "../pages/Wishlist";
import Blog from "../component/Blog";
import ChatWidget from "../component/ChatWidget";
import Faqs from "../component/Faqs/Faqs";
import NotFound from "../Admin/NotFound";
import DiscountGamesPage from "../pages/DiscountGamesPage";
import { FaArrowUp } from "react-icons/fa";
import AttractiveScrollButton from "../component/AttractiveScrollButton";
// import GamingCursor from "../component/GamingCursor";
import Maintenance from "../pages/Maintenance";

// const stripePromise = loadStripe("pk_test_51RlOu04MsbsH6KuURrRtTgj0lZCjFnmdn5A64CpHOHaPl8UwFGlX6jsYe9K9x4XUUSOIeUSisEM3aV5lriLPEw0300n0menKM3");

// Create a wrapper for Payment with Elements
// const PaymentWithStripe = (props) => (
//   <Elements stripe={stripePromise}>
//     <Payment {...props} />
//   </Elements>
// );

const UserRouts = () => {

  // const userId = localStorage.getItem("ottuserId");
  const location = useLocation();
  const hideHeaderFooter = location.pathname === "/login" || location.pathname === "/maintenance";
  // const [detailsPage, setDetailsPage] = useState(false);

  // useEffect(() => {
  //   setDetailsPage(location.pathname.includes("/gamedetails"));
  // }, [location.pathname]);
  const [isChatOpen, setIsChatOpen] = useState(false);

  const isMaintenanceMode = false; // Toggle this to enable/disable maintenance mode

  if (isMaintenanceMode) {
    return (
      <Routes>
        <Route path="*" element={<Maintenance />} />
      </Routes>
    );
  }

  return (
    <div className="userpanel">
      {!hideHeaderFooter && <Header />}
      {/* <GamingCursor /> */}
      <Routes>
        {/* <Route path='/home' element={<Home />}> </Route> */}
        <Route path='/' element={<Home />}> </Route>
        <Route path='/login' element={<Login />}> </Route>
        <Route path='/maintenance' element={<Maintenance />}> </Route>
        <Route path='/games' element={<Products />}> </Route>
        <Route path='/platforms' element={<Platforms />}> </Route>
        <Route path='/gamedetails/:id' element={<GameDetails />}> </Route>
        <Route path='/bundles' element={<Bundles />}> </Route>
        <Route path='/contact' element={<Contact />}> </Route>
        <Route path='/cart' element={<Cart />}> </Route>
        <Route path='/wishlist' element={<Wishlist />}> </Route>
        <Route path='/about' element={<About />}> </Route>
        <Route path='/blog' element={<Blog />}> </Route>
        <Route path="/termsCondition" element={<TermsCondition />}></Route>
        <Route path="/privacyPolicy" element={<PrivacyPolacy />}></Route>
        <Route path="/Faq" element={<Faqs />}></Route>
        <Route path="/discount/:discountId/games" element={<DiscountGamesPage />} />
        <Route path='/profile' element={<Profile />}>
          <Route path="edit-profile" element={<EditProfile />} />
          <Route path="delete" element={<DeleteAccount />} />
          <Route path="orders" element={<Orders />} />
          <Route path="downloads" element={<Downloads />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!hideHeaderFooter && <Footer />}
      <AttractiveScrollButton />
      {!hideHeaderFooter && <ChatWidget onStateChange={setIsChatOpen} />}
    </div>
  );
};

export default UserRouts;